import React from 'react';
import { framedPhotoStyle, normalizedPhotoZoom } from '../../constants/imageCropPresets';
export type PhotoFocus = { x: number; y: number; zoom?: number };
export function PhotoPositionEditor({ src, value, onChange }: { src: string; value: PhotoFocus; onChange: (value: PhotoFocus) => void }) {
  const zoom = normalizedPhotoZoom(value.zoom);
  return <fieldset className="min-w-0 space-y-3">
    <legend className="input-label">Photo framing</legend>
    <div className="w-full aspect-video overflow-hidden rounded-xl bg-black">
      <img src={src} alt="Framing preview" className="w-full h-full" style={framedPhotoStyle(value.x, value.y, zoom)} />
    </div>
    <p className="text-xs text-gray-400">Frame your build for the gallery and card. The image always fills the frame; the original photo is kept.</p>
    {(['x', 'y'] as const).map(axis => <label key={axis} className="block text-sm text-gray-300">
      {axis === 'x' ? 'Horizontal position' : 'Vertical position'}
      <input className="block w-full accent-orange-500" type="range" min="0" max="1" step="0.01" value={value[axis]} onChange={e => onChange({ ...value, [axis]: Number(e.target.value) })} />
    </label>)}
    <label className="block text-sm text-gray-300">
      Zoom · {zoom.toFixed(2)}×
      <input aria-label="Photo zoom" className="block w-full accent-orange-500" type="range" min="1" max="3" step="0.01" value={zoom} onChange={e => onChange({ ...value, zoom: Number(e.target.value) })} />
    </label>
    <button type="button" className="btn-secondary" onClick={() => onChange({ x: 0.5, y: 0.5, zoom: 1 })}>Reset framing</button>
  </fieldset>;
}
